import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const TripManagementComponent = ({ selectLogisticsSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="IsAgentAutoAssignEnabled"
                            name="IsAgentAutoAssignEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ServiceabilitySettings.IsAgentAutoAssignEnabled',
                                    selectLogisticsSettings?.ServiceabilitySettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ServiceabilitySettings?.IsAgentAutoAssignEnabled}
                        />
                        <InputContainer
                            label="IsPOCRequired"
                            name="IsPOCRequired"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ServiceabilitySettings.IsPOCRequired',
                                    selectLogisticsSettings?.ServiceabilitySettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ServiceabilitySettings?.IsPOCRequired}
                        />
                        <InputContainer
                            label="IsPODRequired"
                            name="IsPODRequired"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ServiceabilitySettings.IsPODRequired',
                                    selectLogisticsSettings?.ServiceabilitySettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ServiceabilitySettings?.IsPODRequired}
                        />
                    </div>
                }
                expandedPanel="Trip Management"
                headerTitle="Trip Management"
            />
        </>
    )
}
export default TripManagementComponent;
